import React from 'react';
import {
  ChipField,
  Datagrid,
  FunctionField,
  List,
  ReferenceField,
  TextField,
} from 'react-admin';
import { ExpandRecord } from '../tabs/scheduled_work/ExpandServices';
import { getServiceEntity, getZ3PConfigValue } from '../helper';
import TimeFieldInList from '../components/TimeFieldInList';

const rowClickRedirect = (id) => {
  return `/scheduled-work/${id}/show`;
};

const AppointmentList = (props) => {
  const { selectedDate, selectedServiceVehicleIds } = props;

  const schedulingSystem = getZ3PConfigValue('scheduling_system');
  const isSkippingVehicle = getZ3PConfigValue('is_skipping_vehicle');

  return (
    <div>
      <List
        {...props}
        title=" "
        filter={{
          start_date: selectedDate,
          end_date: selectedDate,
          status_not: 'cancelled',
          service_vehicle_id_is_in: selectedServiceVehicleIds,
        }}
        sort={{ field: 'scheduled_work_id', order: 'ASC' }}
        bulkActionButtons={false}
        perPage={50}
      >
        <Datagrid rowClick={rowClickRedirect} expand={<ExpandRecord />}>
          <ReferenceField
            source="service_vehicle_id"
            reference="service-vehicle"
            link="show"
            label={getServiceEntity()}
          >
            <TextField source="name" />
          </ReferenceField>
          <ReferenceField source="customer_id" reference="customer" link="show">
            <FunctionField
              render={(record) =>
                record ? `${record.first_name} ${record.last_name}` : null
              }
            />
          </ReferenceField>
          <TextField
            source="customer_location"
            label="Address"
            sortable={false}
          />
          {!isSkippingVehicle && (
            <ReferenceField source="vehicle_id" reference="vehicle" allowEmpty>
              <ChipField source="display_name" />
            </ReferenceField>
          )}
          {schedulingSystem === 'availability_windows' && (
            <TimeFieldInList source="planned_arrival_time" />
          )}
          {schedulingSystem === 'availability_windows' && (
            <TimeFieldInList source="planned_departure_time" />
          )}
          {schedulingSystem === 'time_slots' && (
            <TimeFieldInList source="confirmed_appointment_start_time" />
          )}
        </Datagrid>
      </List>
    </div>
  );
};

export default AppointmentList;
